import { Component, OnInit, Input } from '@angular/core';
import { ReadinessTaskPriorityStatusDto } from "../../data/CommandServiceDtos.generated";

@Component({
  selector: 'project-readiness-stage',
  templateUrl: './project-readiness-stage.component.html',
  styleUrls: ['./project-readiness-stage.component.scss']
})
export class ProjectReadinessStageComponent implements OnInit {
  @Input() priority: ReadinessTaskPriorityStatusDto;

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/components/project-readiness-stage/project-readiness-stage.component.ts